import React from 'react';
import { normalizeMediaUrl } from '../Utils/mediaUrls';

const MainImage = ({ imageUrl }) => {
  return (
    <div class="demo_detail_image-grand">
      <img src={normalizeMediaUrl(imageUrl, 'image')} alt="Main" />
    </div>
  );
};

export default MainImage;
